import { useState } from 'react';
import useMockLoading from '../../../../../components/Hooks/useMockLoading';

interface UseChangeOrderStatusModalParams {
  onConfirm: (reason?: string) => Promise<void>;
}

export const useChangeOrderStatusModal = ({ onConfirm }: UseChangeOrderStatusModalParams) => {
  const [reason, setReason] = useState('');

  const { handleAsyncFunction: handleOnConfirm, isLoading } = useMockLoading({
    asyncFunction: async () => {
      await onConfirm(reason);
    },
  });

  return {
    reason,
    isLoading,
    setReason,
    handleOnConfirm,
  };
};
